// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f21a7c2a","513":"e5baaef7","703":"e1b077bf","787":"cda612ba"}[chunkId] + ".chunk.js";
};